import React, { useEffect } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import AOS from "aos";

import "./aplikaisphoenix.css";

export default function AplikasiPhoenix() {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar />

      <div className="container">
        <div className="mainContentAplikasiPhoenix pt-5">
          <h1
            className="text-center pt-5 py-3 text-danger fw-bold"
            data-aos="fade-up"
          >
            Aplikasi Phoenix
          </h1>
          <div className="contentAplikasiPhoenix d-flex justify-content-around pt-lg-3">
            <div className="mainAside" data-aos="fade-up">
              <h4 className="pb-lg-3">Apa Itu Layanan Aplikasi Phoenix?</h4>
              <p>
                Aplikasi Phoenix dapat dibuat sesuai dengan kebutuhan dari
                setiap principal, distributor dan perusahaan manufaktur. Dalam
                aplikasi ini terdapat fitur halaman administrator dan halaman
                mobile aplikasi. Fitur tersebut mempermudah pengguna aplikasi
                dan pihak management perusahaan dalam melihat kondisi dan
                ketersediaan produk. Pelaporan dapat dilihat secara realtime dan
                efisien di semua lokasi/cabang yang tersedia.
              </p>
              <h4 className="pb-lg-3">Mengapa Phoenix?</h4>
              <ul>
                <li>
                  Mempermudah Merchandiser di lapangan untuk mengelola melakukan
                  pendataan data dari masing-masing produk yang ada di merchant
                  atau toko.
                </li>
                <li>
                  Efesiensi dan efektivitas waktu dalam melaksanakan tugas
                  dilapangan.
                </li>
                <li>
                  Data yang yang dikirim realtime sehingga team leader atau PIC
                  nasional dapat melihat aktivitas teamnya, sehingga mengurai
                  keterlambatan dalam pelaporan data.
                </li>
                <li>
                  Management dapat mengontrol dan melihat aktivitas user dan
                  data secara realtime.
                </li>
              </ul>
            </div>
            <div className="text-center" data-aos="fade-left">
              <img
                src={require("../../assets/phoenixapps.png")}
                alt="demophoenix"
                width={"75%"}
              />
            </div>
          </div>
          {/* <div className="text-center" data-aos="fade-right">
            <img
              src={require("../../assets/dashborad-phoenix.png")}
              alt="dashboard-pheonix"
              width={"80%"}
            />
          </div> */}
        </div>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 255">
        <path
          fill="#D30032"
          fill-opacity="1"
          d="M0,192L40,170.7C80,149,160,107,240,117.3C320,128,400,192,480,224C560,256,640,256,720,240C800,224,880,192,960,149.3C1040,107,1120,53,1200,37.3C1280,21,1360,43,1400,53.3L1440,64L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"
        ></path>
      </svg>
      <Footer />
    </>
  );
}
